import { getColorPresetPrimary, AX_TIER_DEFAULT_COLOR_PRESET } from './color-presets';
import type { BrandingConfig } from './types';

/**
 * Tier 1 (core) 기본 브랜딩.
 *
 * 출처: docs/06-branding.md §4.1 — 명시된 값과 일치해야 한다.
 * 탭 아이콘은 `public/favicon.svg` 로 제공한다. 로고 SVG 경로는 빌드 파이프라인에서
 * 별도 자산으로 채운다.
 */
export const defaultBranding: BrandingConfig = {
  productName: 'AX 플랫폼',
  companyName: 'AX Solutions',
  copyrightText: '© 2026 AX Solutions',
  logo: {
    light: '/assets/logo-light.svg',
    dark: '/assets/logo-dark.svg',
    favicon: '/favicon.svg',
  },
  colors: {
    primary: getColorPresetPrimary(AX_TIER_DEFAULT_COLOR_PRESET.core),
    secondary: '#64748B',
  },
  title: 'AX 플랫폼',
  features: {
    showPoweredBy: false,
    allowCustomization: true,
  },
};
